import React, { useEffect, useState } from 'react';
import {
    Typography,
    Divider,
    Box,
    Paper,
    Stack,
    Skeleton
} from '@mui/material';
import Article, { FullScreenArticle } from './../components/Article';
import examples from '../data/article-examples';
import { Form, useNavigate } from 'react-router-dom';
import { useGetSearchResults, usePostSearch } from '../api/ContentApi';
import RoutePaths from '../routes/RoutePaths';
import { FormattedMessage } from 'react-intl';

var DEBUG = false;

const Feed = ({ searchId, setOpen }) => {
    if (DEBUG) console.log("Feed :: Render :: searchId ", searchId);
    const PAGING_LIMIT = 3;
    const searchResults = useGetSearchResults({
        parameters: {
            id: searchId,
            limit: PAGING_LIMIT,
            page: 0,
            //sort_rule: sortOption,
            //sort_order: sortOrder
        }
    });

    return <>
        {
            <Stack
                display="flex"
                flexWrap="wrap"
                direction="row"
                spacing={0}
                alignItems="start"
                justifyContent="start"
            >
                {
                    !searchResults.data &&
                    !searchResults.isError &&
                    searchResults.isLoading &&
                    Array.from({ length: PAGING_LIMIT }).map((_, index) => {
                        return (
                            <Box
                                key={index}
                                sx={{
                                    width: "300px",
                                    height: "150px",
                                    marginRight: "1em",
                                    marginBottom: "1em",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height="100%" />
                            </Box>
                        )
                    })
                }
                {
                    searchResults.data &&
                    !searchResults.isLoading &&
                    !searchResults.isError &&
                    searchResults.data.result.results.map((article, index) => {
                        return (
                            <Article
                                key={index}
                                brand={article.brand}
                                date={article.publish_date}
                                title={article.title}
                                summary={null}
                                actions={true}
                                openAction={() => setOpen(article)}
                                sx={{
                                    width: "300px",
                                    marginRight: "1em",
                                    marginBottom: "1em",
                                }}
                            />
                        )
                    })
                }
                {
                    searchResults.isError &&
                    <Box>
                        <Typography variant="body">
                            <FormattedMessage
                                id="error.results" />
                        </Typography>
                    </Box>
                }
            </Stack>
        }
    </>

}

const LandingPageFeeds = ({ configuration }) => {
    const { landingPageQueries } = configuration;
    if (DEBUG) console.log("LandingPageFeeds :: Render :: ", configuration);

    const navigate = useNavigate();
    const [openArticle, setOpenArticle] = useState(false);

    const searchMutation = usePostSearch({
        onSuccess: (data) => {
            if (DEBUG) console.log("ResultArticles :: searchMutation :: onSuccess ", data);
            navigate(`${RoutePaths.root.search}/${data.result.id}`);
        },
        onError: (error) => {
            console.error("ResultArticles :: searchMutation :: onError ", error);
        }
    });

    const send = (message, context) => {
        if (DEBUG) console.log("ResultArticles :: send");
        //if (DEBUG) console.log(search);
        if (DEBUG) console.log(message);
        //setMessages([...messages, { created: Date.now(), message_content: message, role: 'user' }]);

        searchMutation.mutate({
            query: message,
            filters: null,
            content_ids: context,
        });
    };

    return (
        <>
            <FullScreenArticle
                article={openArticle}
                open={!!openArticle}
                sendAction={send}
                sendMutation={searchMutation}
                setOpen={() => setOpenArticle(null)} />
            <Divider />
            <Typography variant="h4" style={{ textAlign: "left" }}>
                Poimintoja arkistosta
            </Typography>
            {
                landingPageQueries.map((query, index) => {
                    if (DEBUG) console.log("LandingPageFeeds :: query ", query);
                    return (
                        <>
                            <Typography
                                key={query.id}
                                variant="h5"
                                style={{
                                    marginBottom: "-1em",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    navigate(`${RoutePaths.root.search}/${query.id}`);
                                }}>
                                {query.title} ›
                            </Typography>
                            {
                                // TODO: Implement query fetching
                                <Feed
                                    searchId={query.id}
                                    setOpen={setOpenArticle} />
                            }
                        </>
                    );
                })
            }
        </>
    );
}

export default LandingPageFeeds;